module.exports = __webpack_public_path__ + "media/images/ic-data-d6c0b704682bc54c7badbb08912476da.svg";